module.exports = "/virtual-football-league/img/amblems/right/France/Fake_Bordeaux.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/France/Fake_Bordeaux.png
// module id = 2133
// module chunks = 4